<template>
  <div class="min-vh-100 bg-light">
    <div class="container-fluid min-vh-100">
      <div class="row align-items-center min-vh-100">
        <div class="col">
          <div class="card shadow vld-parent">
            <loading :active="isLoading" :color="'#ff0090'" :loader="'bars'" :is-full-page="false"></loading>
            <div class="card-body">
              <div class="logo mx-auto pt-4 pb-5">
                <img src="@/assets/images/predictile-logo-square.png" />
              </div>
              <div v-if="isLoading">
                <h4 class="mb-4 text-center">Confirming Phone Number...</h4>
                <p class="text-center">
                  <fa icon="sync" spin size="2x" />
                </p>
              </div>
              <div v-if="!isLoading">
                <h4 class="mb-4 text-center">Confirm Phone Number</h4>
                <p class="lead text-center">{{ message }}</p>
                <div v-if="success" class="form-group text-right">
                  <button type="button" class="btn btn-block btn-lg btn-outline-primary sign-in-btn mt-4" @click="href('/signin')">
                    Sign in
                  </button>
                </div>
              </div>
              <div class="form-group text-center footer mt-4">
                <button type="button" class="btn btn-link" @click="href('/signup')">
                  Sign Up
                </button>
                <span>|</span>
                <a href="https://www.predictile.com/support">Support</a>
                <br />
                <a href="https://www.predictile.com/member-terms-of-service/index.html">Member Terms of Service</a>
                <span>|</span>
                <a href="https://www.predictile.com/privacy-policy/index.html">Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserConfirmPhoneNumberView",
  props: ["userId"],
  data() {
    return {
      isLoading: false,
      success: null,
      message: null,
    };
  },
  computed: {
    expiration() {
      return this.$route.query.exp;
    },
    code() {
      return this.$route.query.code;
    },
  },
  mounted() {
    this.isLoading = true;
    this.$axios
      .post(`/users/${this.userId}/confirm/phone`, { expiration: this.expiration, code: this.code })
      .then(() => {
        this.isLoading = false;
        this.message = "Your phone number has been confirmed. Thank you!";
        this.success = true;
      })
      .catch((err) => {
        this.isLoading = false;
        this.message = err && err[0] ? err[0].message : "An unknown error occured.";
        this.success = false;
      });
  },
  methods: {
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.logo {
  width: 200px;

  img {
    width: 200px;
  }
}

.footer {
  font-size: $font-size-sm;

  button {
    font-size: $font-size-sm;
  }

  a {
    font-size: $font-size-sm;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

@media (min-width: 768px) {
  .container-fluid {
    width: 450px;
  }
}
</style>
